import React from 'react'
import { Alert, Box, Typography } from '@mui/material'
import { formatNumber } from 'utils/helpers'

export interface CommodityError {
  commodityId: string
  commodityName: string
  threshold: number
  value: number
  type: 'FERROUS' | 'NON_FERROUS'
}

interface Props {
  costThresholdErrors: CommodityError[]
}

const CommodityTypeCostThresholdAlert = ({ costThresholdErrors }: Props) => {
  if (!costThresholdErrors || costThresholdErrors.length === 0) return null

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Commodity Type Threshold Exceeded
      </Typography>
      <Box>
        {costThresholdErrors.map((error, index) => (
          <Typography
            key={error.commodityId}
            variant="body2"
            sx={{ mb: index < costThresholdErrors.length - 1 ? 1 : 0 }}
          >
            <strong>{error.type === 'FERROUS' ? 'Ferrous' : 'Non-Ferrous'}</strong>
            {` cost of $${formatNumber(error.value)} exceeds the threshold of `}
            <strong>{`$${formatNumber(error.threshold)}`}</strong>
            {` for ${error.commodityName}`}
          </Typography>
        ))}
      </Box>
    </Alert>
  )
}

export default CommodityTypeCostThresholdAlert
